import { MenuItem, Select } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useGetClientEntityGroupQuery } from '../../services/features/clientApi/clientApi';
import CreateQuoteSectionTitle from '../CreateQuoteSectionTitle';

export const ClientEntityGroupSelect = ({ options }: { options: any }) => {
	const formik = useMemo(() => options, [options]);

	const entityGroupQuery = useGetClientEntityGroupQuery(undefined);

	const [entityId, setEntityId] = useState<any>('');

	useEffect(() => {
		setEntityId(formik.values.entityGroup?.id ?? '');
	}, [formik.values.entityGroup]);

	return (
		<>
			<CreateQuoteSectionTitle title={'What type of entity are you looking to insure?'} />
			<Select
				fullWidth
				disabled={entityGroupQuery.isLoading || entityGroupQuery.isUninitialized}
				value={entityId}
				displayEmpty
				renderValue={(id) => {
					const newEntityGroup = entityGroupQuery.data?.find(
						(entityGroup) => entityGroup.id === id
					);
					if (!newEntityGroup) {
						return (
							<span style={{ color: 'rgba(0, 0, 0, 0.35)' }}>Select Entity Type</span>
						);
					}
					return newEntityGroup?.name;
				}}
				onChange={(e) => {
					const id: any = e.target.value;
					const newEntityGroup = entityGroupQuery.data?.find(
						(entityGroup) => entityGroup.id === id
					);
					// formik.resetForm();
					[
						'acnBusinessNumber',
						'businessNumber',
						'companyName',
						'occupation',
						'suboccupationId',
						'streetName',
						'city',
						'postcode',
					].forEach((v) => {
						formik.setFieldValue(v, '');
					});
                    formik.setFieldValue('region', 'QLD');
					setEntityId(id ?? '');
					formik.setFieldValue('entityGroup', newEntityGroup);
				}}
			>
				{(entityGroupQuery.data ?? []).map((entityGroup) => (
					<MenuItem key={`entity-group-${entityGroup.id}`} value={entityGroup.id}>
						{entityGroup.name}
					</MenuItem>
				))}
			</Select>
		</>
	);
};
